// Detects which optional Freeform fields exist on a given form, so MenorahForm can
// conditionally render/validate/post fields that only some ICC landing pages have
// configured (see SAJOB-6530 — local-review/SAJOB-6530-freeform-resident-fields.md).
//
// Fields live in one shared, global `freeform_fields` table (see the spec's
// "Freeform findings" appendix) but are only attached to a given form's layout when
// someone explicitly drags them in via the CP. `freeformObj.fields` (the flattened,
// per-form field list returned by stores/Globals/query.graphql) already reflects
// that per-form attachment, so checking it is sufficient — no query changes needed.

type FreeformFieldHandle = NonNullable<FreeformFieldInterface['handle']>;

// Returns the set of field handles present on a form, for O(1) membership checks
// when multiple handles need to be checked against the same form (see
// getResidentFieldPresence in index.tsx, which builds this once and derives several
// presence flags from it).
export const getFormFieldHandles = (
  freeformObj?: FreeformFormInterface | null,
): Set<FreeformFieldHandle> => {
  const handles = (freeformObj?.fields || [])
    .map((field) => field?.handle)
    .filter((handle): handle is FreeformFieldHandle => !!handle);

  return new Set(handles);
};
